import { c as _c } from "react/compiler-runtime";
import IconDesktop from "./last-second-icon-desktop.svg";
import IconMediumMobile from "./last-second-icon-medium-mobile.svg";
import IconMedium from "./last-second-icon-medium.svg";
import IconMobile from "./last-second-icon-mobile.svg";
export const HotelLastSecondIcon: React.FC<{
  size?: "small" | "large" | "medium";
}> = t0 => {
  const $ = _c(3);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  if (size === "small") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <img alt="" width={131} height={60} src={IconMobile.src} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (size === "medium") {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <><img width={131} className="md:hidden" height={60} src={IconMediumMobile.src} alt="" /><img width={204} className="hidden md:block" height={60} src={IconMedium.src} alt="" /></>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <img width={150} height={238} src={IconDesktop.src} alt="" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};